import React from 'react'
import Select from 'react-select';
const CentralExciseDuty = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const basicDutyOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const basicUnit = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className='card'>
            <div className="card-body">
                <form>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        CETH No
                                    </label>
                                </div>
                                <Select
                                    className='custom-selector w-auto'
                                    options={basicDutyOpt}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        MRP Status
                                    </label>

                                </div>
                                <Select
                                    className='custom-selector w-auto'
                                    options={basicDutyOpt}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header font-medium py-2">
                                    MRP Duty
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-8 mb-2">

                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">

                                                    MRP Rs.
                                                </label>

                                            </div>
                                            <div className='d-flex justify-content-start align-items-center gap-1'>
                                                <div className='d-flex'>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm w-auto"
                                                        id="name"
                                                        name="name"
                                                        defaultValue="0.00"
                                                    />
                                                    <div className="text-xs">
                                                        /Unit
                                                    </div>
                                                </div>
                                                <div className='d-flex'>

                                                    <div className="text-xs">
                                                        -Abt@
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm w-auto"
                                                        id="name"
                                                        name="name"
                                                        defaultValue="0.00"
                                                    />
                                                    <div className="text-xs">
                                                        %
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    SrNo in List
                                                </label>
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                                defaultValue="0.00"
                                            />


                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    RSP Notification
                                                </label>
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                                defaultValue="0.00"
                                            />


                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Sr No
                                                </label>
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                                defaultValue="0.00"
                                            />


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Addl Duty (Excise Duty)
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        AIDC
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Education Cess
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <div className="text-xs">
                                        Sec & Hig. E Cess
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>


                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Addl. Duty (Sub-Section 5)
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>

                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Addl. Duty of Excise (GSI)
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Spl. Excise Duty (Sched-II)
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Addl. Duty of Excise (TTA)
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Health Cess
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Cess & Notification
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicUnit}
                                    />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Infrastructure Cess
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">

                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                    <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Close
                        </button>

                    </div>


                </form>
            </div>
        </div>
    )
}

export default CentralExciseDuty